import type { ConfigAccountType } from '@/modules/projects/stores/caseConfig'
import { cn } from '@/utils'

interface AccountTypeFieldProps {
  options: ConfigAccountType[]
  value: string
  onChange: (value: string) => void
}

export const AccountTypeField = ({
  options,
  value,
  onChange,
}: AccountTypeFieldProps) => (
  <fieldset className="space-y-2">
    <legend className="text-sm font-medium">Account type</legend>
    <div className="flex flex-wrap gap-2">
      {options.map((option) => (
        <label
          key={option.key}
          className={cn(
            'cursor-pointer rounded-lg border px-4 py-2 text-sm font-medium transition-colors',
            'has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-brand has-[:focus-visible]:ring-offset-2',
            value === option.key
              ? 'border-brand bg-brand/5 ring-1 ring-brand'
              : 'border-border bg-white text-muted-foreground hover:bg-muted/50',
          )}
        >
          <input
            type="radio"
            name="case_accounts_type"
            value={option.key}
            checked={value === option.key}
            onChange={() => onChange(option.key)}
            className="sr-only"
          />
          {option.label}
        </label>
      ))}
    </div>
  </fieldset>
)
